import { shape, string } from 'prop-types';
import StoreHeader from '../../features/store-header/store-header';
import Gallery from '../../features/gallery/gallery.desktop';
import Onboarding from '../../features/onboarding/onboarding.desktop';
import CPG from '../../features/cpg/header-cpg.desktop';
import { useState } from 'react';

// Head Section
import RelatedSearches from '../../features/related-searches';

import ItemStatusHead from '../../features/item-status/head';
import RedirectFromStatus from '../../features/item-status/redirected-from';
import RecommendationsCarouselFreeHorizontal from '../../features/recommendations/carousel-free-horizontal';
import RecommendationsCarouselSnappedHorizontal from '../../features/recommendations/carousel-snapped-horizontal';
import GroupedHeader from './sections/grouped-header';

// Short Description
import Bookmark from '../../features/bookmark';

import Header from '../../features/header/header.desktop';
import Price from '../../features/price/price.desktop';
import PromotionTop from '../../features/promotions-top';
import PromotionBottom from '../../features/promotions-bottom';
import Promotions from '../../features/promotions/promotions';
import Highlights from '../../features/highlights/highlights';
import PaymentSummary from '../../features/payment-summary/payment-summary.desktop';
import CpgSummary from '../../features/cpg/summary.desktop';
import ShippingSummary from '../../features/shipping-summary/shipping-summary.desktop';
import MoqInformation from '../../features/moq-information/moq-information.desktop';
import SpecialShippingSummary from '../../features/special-shipping-summary/special-shipping-summary';
import SecondShippingSummary from '../../features/second-shipping-summary/second-shipping-summary.desktop';
import ThirdShippingSummary from '../../features/third-shipping-summary/third-shipping-summary.desktop';
import PickUpSummary from '../../features/pick-up-summary/pick-up-summary.desktop';
import MeliplusLabel from '../../features/meliplus-label/meliplus-label';
import MeliplusSummary from '../../features/meliplus-summary/meliplus-summary.desktop';
import UpsellingMeliplusSummary from '../../features/upselling-meliplus-summary/upselling-meliplus-summary.desktop';
import CbtTaxesSummary from '../../../../../components/cbt-taxes/cbt-taxes-summary.desktop';
import CbtTaxesFcUsSummary from '../../../../../components/cbt-taxes-fc-us/cbt-taxes-fc-us-summary.desktop';
import ReturnsSummary from '../../features/returns-summary/returns-summary.desktop';
import Variations from '../../features/variations/variations.desktop';
import ItemStatusShortDescription from '../../features/item-status/short-description';
import Seller from '../../features/seller/seller.desktop';
import SellerInfo from '../../features/seller-info/seller-info.desktop';
import MerchEcosystem from '../../features/merch-ecosystem/merch-ecosystem.desktop';
import StockInformation from '../../features/stock-information/stock-information.desktop';
import FulfillmentInformation from '../../features/fulfillment-information/fulfillment-information';
import PaypalTooltip from '../../features/tooltips/paypal-tooltip';
import TopAvailableQuantitySummary from '../../features/top-available-quantity-summary/top-available-quantity-summary.mobile';
import AvailableQuantity from '../../features/available-quantity/available-quantity.desktop';
import MainActions from '../../features/main-actions/main-actions.desktop';
import CartActions from '../../features/cart-actions/cart-actions.desktop';
import CreditsTooltip from '../../features/tooltips/credits-tooltip';
import ShippingCartBenefitsTooltip from '../../features/tooltips/shipping-cart-benefits-tooltip';
import LoyaltyTooltip from '../../features/tooltips/loyalty-tooltip';
import BuyBenefits from '../../features/buy-benefits/buy-benefits.desktop';
import HeaderTopBrandFixed from '../../features/header-top-brand/header-top-brand.desktop';
import PricePerQuantityShortcuts from '../../features/price-per-quantity-shortcuts';

// Content Left
import TechnicalSpecifications from '../../features/technical-specifications/technical-specifications.desktop';

import ApparelSizeSpecsPreview from '../../features/apparel-size-specs-preview/apparel-size-specs-preview.desktop';
import HighlightedSpecsAttrs from '../../features/highlighted-specs/highlighted-specs-attrs.desktop';
import Description from '../../features/description/description.desktop';
import Questions from '../../features/questions/questions.desktop';
import QADB from '../../features/qadb';
import Reviews from '../../features/reviews/reviews.desktop';
import { spotMiddleMobileRender } from '../../../../../utils/spotMiddleRenders';

// Content Right
import Warranty from '../../features/warranty/warranty.desktop';

import Returns from '../../features/returns/returns.desktop';
import PaymentMethods from '../../features/payment-methods/payment-methods.desktop';
import RecommendationsListPads from '../../features/recommendations/list-pads';

// Content Bottom
import Denounce from '../../features/denounce';
import ExtendedMenu from '../../../../../pages/vpp/features/extended-menu/extended-menu.desktop';

// Recommendations
import RecommendationsCarouselFree from '../../features/recommendations/carousel-free';

import RecommendationsCarouselSnapped from '../../features/recommendations/carousel-snapped';

// General
import View from '../view';

import Snackbar from '../../features/snackbar';
import DynamicComponentWrapper from '../../features/dynamic-component-wrapper';
import renderSwapComponent from '../../features/dynamic-component-wrapper/render-swap-component';
import GroupedShareBookmark from '../../features/grouped-share-bookmark';
import GiftRegistry from '../../features/gift-registry';
import Grid from '../../../../../components/grid';

// Dynamic Shipping Wrapper (for order swap)
const renderTopShipping = renderSwapComponent('meliplus_summary', <MeliplusSummary />, <ShippingSummary />);

const CoreTablet = props => {
  const [lastUnitBuyBoxOffer, setLastUnitBuyBoxOffer] = useState(false);

  return (
    <View {...props} vertical="core">
      <Onboarding />
      <CPG />
      <Grid.Container className="ui-pdp-container--top">
        <Grid.Row>
          <Grid.Col className="ui-vip-core-container--head">
            <RelatedSearches />
            <RedirectFromStatus />
            <ItemStatusHead />
            <RecommendationsCarouselFreeHorizontal
              featureName="carousel_cheaper"
              className="pt-12 pb-4 pl-0 pr-0 tablet-layout"
              lazy={false}
              preload
              fetchPriority="high"
              criticalImages={3}
            />
            <RecommendationsCarouselFree
              featureName="carousel_v2p_not_active_item"
              className="mb-24 mt-24"
              lazy={false}
              preload
              fetchPriority="high"
              criticalImages={3}
            />
            <RecommendationsCarouselFreeHorizontal
              featureName="carousel_neighbour_top"
              className="pt-12 pb-4 pl-0 pr-0 tablet-layout"
              lazy={false}
              preload
              fetchPriority="high"
              criticalImages={3}
            />
            <GroupedHeader />
          </Grid.Col>
        </Grid.Row>
      </Grid.Container>
      <Grid.Container>
        <StoreHeader />
        <HeaderTopBrandFixed />
      </Grid.Container>
      <Grid.Container className="ui-pdp-container--pdp">
        <Grid.Row id="ui-pdp-main-container" className="ui-pdp--relative  pb-40">
          <Grid.Col className="ui-pdp-container--column-left pb-40" size={2}>
            <Grid.Row>
              <Grid.Col size={2}>
                <Gallery />
              </Grid.Col>
            </Grid.Row>
            <Grid.Col className="ui-vip-core-container--content-left">
              <RecommendationsCarouselFree
                featureName="carousel_up_web"
                className="ui-pdp-carousel-snapped-up"
                paddingHorizontal={0}
              />
              <RecommendationsCarouselSnappedHorizontal
                featureName="carousel_above_swap"
                className="ui-pdp-carousel-snapped-up no-border"
                slidesPerView={2}
                arrowsSize="small"
              />
              <RecommendationsCarouselFree
                featureName="carousel_above"
                className="ui-pdp-carousel-snapped-up"
                paddingHorizontal={0}
              />
              <RecommendationsCarouselFree
                featureName="carousel_above_pads"
                className="ui-pdp-carousel-snapped-up"
                paddingHorizontal={0}
              />
              <TechnicalSpecifications />
              <ApparelSizeSpecsPreview />
              <HighlightedSpecsAttrs />
              <Description />
              <DynamicComponentWrapper
                renderDynamicComponent={spotMiddleMobileRender({
                  firstChildClassName: 'ui-pdp-with--separator-top ui-pdp-with--separator-top--full mb-40',
                  lastChildClassName: '',
                  middleChildClassName: 'mt-40 mb-40',
                  paddingHorizontal: 0,
                })}
                className="ui-vip-core-spot-middle"
                spot="spot_middle"
              />
              <QADB />
              <Questions />
              <Grid.Col size={3}>
                <Reviews />
              </Grid.Col>
              <Grid.Col size={3}>
                <RecommendationsCarouselSnapped
                  featureName="carousel_vis_cross_selling_acc"
                  className="ui-pdp-vis-carousel-b2c"
                  slidesPerView={3}
                  lazy={false}
                />
              </Grid.Col>
            </Grid.Col>
          </Grid.Col>
          <Grid.Col className="ui-pdp-container--column-right mt-16 pr-16">
            <Grid.Row className="ui-pdp-component-list pr-16 pl-16">
              <Grid.Col
                size={2}
                className="ui-vip-core-container--short-description ui-vip-core-container--column__right"
              >
                <Header>
                  <Bookmark showLabel={false} />
                </Header>
                <Highlights className="ui-pdp-highlights" />
                <PromotionTop className="ui-pdp-highlights mt-16" />
                <Price />
                <PricePerQuantityShortcuts className="mt-20" locale={props?.country?.locale} />
                <PromotionBottom className="ui-pdp-highlights mt-24" />
                <Promotions className="ui-pdp-highlights mt-12" />
                <CbtTaxesFcUsSummary />
                <PaymentSummary />
                <CpgSummary />
                <MeliplusLabel className="ui-pdp-meliplus-label" />
                <SpecialShippingSummary />
                <DynamicComponentWrapper renderDynamicComponent={renderTopShipping} spot="top_shipping" />
                <SecondShippingSummary />
                <ThirdShippingSummary />
                <PickUpSummary />
                <UpsellingMeliplusSummary />
                <CbtTaxesSummary />
                <ReturnsSummary />
                <Variations />
                <ItemStatusShortDescription />
                <Seller />
                {!lastUnitBuyBoxOffer && (
                  <div className="ui-pdp-container__row--stock-and-full">
                    <StockInformation />
                    <FulfillmentInformation />
                  </div>
                )}
                <TopAvailableQuantitySummary />
                <AvailableQuantity setLastUnitBuyBoxOffer={setLastUnitBuyBoxOffer} />
                {lastUnitBuyBoxOffer && (
                  <div className="ui-pdp-container__row--stock-and-full-last">
                    <StockInformation />
                    <FulfillmentInformation />
                  </div>
                )}
                <MoqInformation />
                <PaypalTooltip />
                <MainActions />
                <CartActions />
                <CreditsTooltip />
                <ShippingCartBenefitsTooltip />
                <LoyaltyTooltip />
                <BuyBenefits />
                <GiftRegistry className="mt-24" />
                <GroupedShareBookmark className="mt-24" showOnlyForWishlistVariant />
              </Grid.Col>
            </Grid.Row>
            <Grid.Row className="ui-pdp-component-list ui-vip-content-right mt-16">
              <SellerInfo />
            </Grid.Row>
            <Grid.Row>
              <MerchEcosystem className="mt-16" />
            </Grid.Row>
            <Grid.Row className="ui-pdp-component-list ui-vip-content-right mt-16">
              <Returns />
              <Warranty />
              <PaymentMethods />
            </Grid.Row>
            <Grid.Row className="ui-pdp-component-list ui-vip-content-right mt-16">
              <RecommendationsListPads
                featureName="advertising_vip_right"
                className="ui-box-component ui-box-component--block"
              />
            </Grid.Row>
          </Grid.Col>
        </Grid.Row>
      </Grid.Container>
      <Grid.Container className="ui-pdp-container--bottom">
        <Denounce />
        <DynamicComponentWrapper
          renderDynamicComponent={featureName => (
            <RecommendationsCarouselFree
              className="mb-24 mt-16"
              paddingHorizontal={0}
              featureName={featureName}
              overWhiteBackground={false}
            />
          )}
          spot="carousel_bottom"
        />
        <ExtendedMenu />
      </Grid.Container>
      <Snackbar />
    </View>
  );
};

CoreTablet.propTypes = {
  initialState: shape().isRequired,
  country: shape({ locale: string }),
};

export default CoreTablet;
